/**
 * Parser tollerante per coordinate. Accetta:
 *  - decimali: "44.82954", "-44.82954", "44,82954"
 *  - DMS:      `44°49'46.362"`, `44° 49' 46.362"`, con varianti di apici (' ' ′ " " ″)
 *  - DM:       `44°49.7727'`
 *  - emisfero: suffisso N/S/E/W (S e W diventano negativi)
 *
 * Ritorna null se non riconoscibile.
 */
export function parseCoordinate(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  // Caso veloce: numero decimale puro (gestendo virgola decimale italiana)
  const asPlain = Number(trimmed.replace(',', '.'));
  if (Number.isFinite(asPlain) && !/[°'"′″’”′″NSEWnsew]/.test(trimmed)) {
    return asPlain;
  }

  const dms =
    /^\s*(-?)\s*(\d+(?:[.,]\d+)?)\s*°?\s*(?:(\d+(?:[.,]\d+)?)\s*['’′]?\s*(?:(\d+(?:[.,]\d+)?)\s*["”″]?)?)?\s*([NSEWnsew])?\s*$/;
  const m = trimmed.match(dms);
  if (!m || !m[2]) return null;

  const sign = m[1] === '-' ? -1 : 1;
  const deg = Number(m[2].replace(',', '.'));
  const min = m[3] ? Number(m[3].replace(',', '.')) : 0;
  const sec = m[4] ? Number(m[4].replace(',', '.')) : 0;
  const hemi = m[5]?.toUpperCase();

  if (!Number.isFinite(deg) || !Number.isFinite(min) || !Number.isFinite(sec)) return null;
  if (min < 0 || min >= 60 || sec < 0 || sec >= 60) return null;

  let value = (deg + min / 60 + sec / 3600) * sign;
  if (hemi === 'S' || hemi === 'W') value = -Math.abs(value);
  return value;
}

/** Normalizza l'input di un campo coord in formato decimale a 6 cifre.
 *  Se non parsabile, ritorna il raw originale (l'errore verrà mostrato al submit). */
export function normalizeCoordinateInput(raw: string): string {
  const parsed = parseCoordinate(raw);
  if (parsed === null) return raw;
  return parsed.toFixed(6);
}
